import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios

//Modelos

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJDUV from './NewDJDUV';

function NewDJDUVContainer() {
    const { toast, token, grapesVariety } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [DJDUVData, setDJDUVData] = useState();

    const FormMethods = useForm();

    useEffect(() => {
        // async function fetchDJDUV() {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJDUV segun el id de los params
        //         const DJDUV = await DJDUVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         if (DJDUV) {
        //             //Establecemos los datos para la nueva DJDUV
        //             const newDJDUV = new NewDJCPModel({
        //                 cabecera: DJDUV.data.cabecera,
        //                 items: DJDUV.data.items,
        //             });
        //             setDJDUVData(newDJDUV);
        //             setTableData(buildTableData(newDJDUV.items));
        //             //Establecemos los valores iniciales del form
        //             let formValues = {};
        //             DJDUV.data.items.forEach((it, i) => {
        //                 formValues[`kilos` + i] = it.kilos;
        //             });
        //             FormMethods.reset(formValues);
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // }
        // fetchDJDUV();
    }, []);

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            let formItems = { ...DJDUVData };
            formItems.items.forEach((it, i) => {
                it.kilos = parseInt(data[`kilos` + i]);
            });

            //Peticion para actualizar la DJDUV
            // const UpdateDJCMV = await DJDUVService.update({
            //     token,
            //     declaracion: formItems,
            // });

            // //Si la respuesta es correcta, navegamos denuevo a la tabla de DJDUVs y desplegamos mensaje de éxito
            // if (UpdateDJCMV) {
            //     Navigate(RoutesApp.Declaraciones.transferenciaViniedo);
            //     toast('DJDUV enviada con éxito', { type: 'success' });
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    };

    /**Funcion que crea el objeto para pasarle a la tabla que lista las DJDUVs */
    const buildTableData = (
        data = [
            { id: 0, variedad: 0, superficie: 0, kilos: 0, id_declaracion: 0 },
        ]
    ) => {
        return {
            headers: ['Variedad de Uva', 'Superficie', 'Kilos Probables'],
            pagination: 10,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    superficie: `${dj.superficie} m²`,
                    kilos: (
                        <input
                            {...FormMethods.register('kilos' + i)}
                            type={'number'}
                        />
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <NewDJDUV
            functions={{
                ...FormMethods,
                onSubmit,
            }}
            states={{ tableData, DJDUVData }}
        />
    );
}

export default NewDJDUVContainer;
